export class ProviderCouponModel{
    providerAlias?:string;
    type?:string;
    couponCode?:string;
    url?:string;
}